import defaultTheme from './defaultTheme';
export default {
  ...defaultTheme,
  background: '#e9eef5',
  profileIndicatorBG: '#fff',
  stepIndicatorLabelFinishedColor: '#00ab5e',
  stepIndicatorLabelUnFinishedColor: '#005189',
  profileIndicatorBtn: '#005189',
  profileIndicatorBtnBorder: '#005189',
  profileIndicatorBtnLabel: '#fff'
};
